module.exports = __webpack_public_path__ + "static/img/son2.37e837f7.jpg";